import { PillToggleVariant } from './pill-toggle.type';

export const PILL_TOGGLE_VARIANT_CLASSES: Record<PillToggleVariant, string> = {
  critical: 'bg-critical text-critical',
  warning: 'bg-yellow-soft text-yellow-hard',
  success: 'bg-success text-success',
  neutral: 'bg-neutral-0 dark:bg-neutral-70 text-primary',
};
